module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3f.eaa543cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3f.svg
// module id = 553
// module chunks = 0